import React, { useState, useEffect, useRef } from 'react';
import './DocumentPreview.css';
import { withTranslation } from 'react-i18next';
import { Button, ListGroup, Tabs, Tab, Col, Nav, Row, ProgressBar } from "react-bootstrap";
import ToastComponent from '../Toast/Toast';
import iconAttachedDocs from '../../assets/icons/attachedDocs.svg';
import iconBackButton from '../../assets/icons/backButton.svg';
import iconNextButton from '../../assets/icons/nextButton.svg';
import iconArrowDown from '../../assets/icons/arrow_down.svg';
import iconArrowUp from '../../assets/icons/arrow_up.svg';
import iconQuestionBox from '../../assets/icons/question_box.svg';
import squareEyeBox from '../../assets/icons/square-eye.svg';
import squareDocBox from '../../assets/icons/square-doc.svg';
import downloadIcon from '../../assets/icons/download.svg';
import lockIcon from '../../assets/icons/lock.png';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import Utils from '../../services/Utils';
import SigningProcessModal from '../Modals/SigningProcessModal';
import RejectingProcessModal from '../Modals/RejectingProcessModal';
import LoadingCircle from '../LoadingCircle';
import ProfileService from '../../services/Profile/ProfileService';
import CertificateService from '../../services/Certificate/CertificateService';
import DocumentService from '../../services/Document/DocumentService';
import { CustomModal } from '../CustomModal/CustomModal';
import { NEBULA, REDTRUST, REDTRUST_CERTIFICATE_PIN_KEY, KEYVAULT, KEYVAULT_CERTIFICATE_PIN_KEY, FIRMAREMOTA, SOFTWARE, SOFTWARE_CERTIFICATE_PIN_KEY, UANATACA, UANATACA_CERTIFICATE_PIN_KEY, SWISSCOM, NEBULA_CERTIFICATE_PIN_KEY, OTP, VALIDATEDID_CERTIFICATE_PIN_KEY, VALIDATEDID, PREVIEW, IVNOSYS } from '../../services/signatureMethods/constants';
import {
  generateRedTrustUri,
  postPrivSignature,
  generateKeyVaultUri,
  generateKeyVaultSendOTPUri,
  deleteManagementSignature,
  generateFirmaRemotaOTPUri,
  generateFirmaRemotaSessionUri,
  generateFirmaRemotaUri,
  putManagementSignature,
  putPrivSignature,
  generateUanatacaUri,
  generateSoftwareUri,
  generateSwisscomUri,
  postManagementSignature,
  generateNebulaAuthMiddleUri,
  generateNebulaAuthEndUri,
  generateNebulaUri,
  generateNebulaAuthUri,
  generateUanatacaOtpUri,
  generateValidatedIdOtpUri,
  generateValidatedIdUri,
} from '../../services/signatureMethods/customServiceSignature';
import KeyVaultSignature from '../KeyVaultSignature/KeyVaultSignature.component';
import RedTrustSignature from '../RedTrustSignature/RedTrustSignature.component';
import DesktopOnlyMessage from '../DesktopOnlyMessage/DesktopOnlyMessage';
import { isMobile, isTablet } from '../../services/device/deviceService';
import FirmaRemota from '../FirmaRemota/FirmaRemota.component';
import UanatacaSignature from '../UanatacaSignature/UanatacaSignature.component';
import SoftwareSignature from '../SotwareSignature/SoftwareSignature.component';
import SwisscomSignature from '../SwisscomSignature/SwisscomSignature.component';
import NebulaSignature from '../NebulaSignature/NebulaSignature.component';
import { checkShowNoPinConfirmationModal } from '../../services/signatureMethods/helperService';
import ValidatedIdSignature from '../ValidatedIdSignature/ValidatedIdSignature.component';
import documentMapService from '../../services/documentMapService/documentMapService';
import IvnosysSignature from '../IvnosysSignature/IvnosysSignature.component';
import { DocumentAttachments } from '../DocumentAttachments/DocumentAttachments';
import { RejectionModal } from '../RejectionModal/RejectionModal';
import VCSignature, { VC_SIGN_STORAGE } from '../VCSignature/VCSignature.component';
import vcService from '../../services/vcService';

const ipLocation = require("iplocation");
const publicIp = require('public-ip');
const { detect } = require('detect-browser');
const browser = detect();

const DocumentPreview = (props) => {
  const {
    t,
    renderedDoc,
    selectedDoc,
    pendingSignatures,
    documentSigners,
    documentAttatchmentsList,
    attDocArray,
    totalPages,
    checkedDocs,
    updateSelectedDocs,
    isDocSelectionLocked,
    getSelectionLockTooltipKey,
    forceDocumentView,
    renderSpecificPage,
    loadingMorePages,
    docsAttachedRendered,
  } = props;

  const [state, setStateRaw] = useState({
    oauthTokenB64: sessionStorage.getItem('oauthTokenB64'),
    environment: sessionStorage.getItem('environment'),
    language: localStorage.getItem('i18nextLng'),
    showSignModal: false,
    showRejectModal: false,
    time: 0,
    showKeyVaultModal: false,
    showVCSignatureModal: false,
    showFirmaRemotaModal: false,
    showRedTrustModal: false,
    showSoftwareModal: false,
    showUanatacaModalPin: false,
    showUanatacaModalOtp: false,
    showValidatedIdModalPin: false,
    showValidatedIdModalOtp: false,
    showSwisscomModal: false,
    showAutofirmaModal: false,
    showNebulaModal: false,
    showSwisscomConfirmationModal: false,
    showNoPinConfirmationModal: false,
    showIvnosysModal: false,
    showDesktopOnlyModal: false,
    certificateSoftwarePin: '',
    certificateKeyVaultPin: '',
    certificateFirmaRemotaPin: '',
    certificateRedTrustPin: '',
    certificateUanatacaPin: '',
    certificateUanatacaOtp: '',
    certificateValidatedIdPin: '',
    certificateValidatedIdOtp: '',
    certificateNebulaPin: '',
    certificateSelected: {},
    loadingSignatureProcess: false,
    loadingRejectingProcess: false,
    sessionOpened: false,
    showError: false,
    errorData: '',
    errorType: '',
    rejectReason: '',
    actualPage: 1,
    actualAttachedPage: 1,
    sideMenuOption: 1,
    tabKey: 0,
    certTitleTabs: [],
    swisscomRedirectURL: "",
    swisscomRequestID: "",
    loadingSwisscomRequest: false,
    loadingSignatureProcessAutofirma: false,
    loadingSwisscomCheck: false,
    swisscomError: '',
    autofirmaError: '',
    autofirmaPercentage: 0,
    clientIp: '',
    ipData: '',
    showSignatureReason: true,
    vuserCertsFiltered: [],
    nebulaStep1: false,
    nebulaStep2: false,
    nebulaStep3: false,
    nebulaPinRequired: true,
    isUanatacaQualified: false,
    isValidatedIdQualified: false,
    showHeaderInfo: true,
    accessMethod: sessionStorage.getItem("AccessMethod"),
    allPagesViewed: false,
    selectedPage: 1,
    errorMessage: '',
    isManualNavigation: false,
    totalDocumentHeight: 0,
    loadedImagesCount: 0,
    showErrorModalSelectedPage: false,
    loading: false,
    userData: null,
    userCertificatesAuth: null,
    certificatesList: null,
    docsSigned: 0,
    sessionExpired: false,
    redirect: false,
    NBauthenticator: '',
    NBChallenge: '',
    NBAuthenticator: '',
    loadingNebula: false,
    certificateIvnosysPin: '',
    showAdditionalSignaturesDisclaimer: false,
    showChallengeError: false,
    textAdditionalSignaturesDisclaimer: '',
    titleAdditionalSignaturesDisclaimer: '',
    triggerSign: false,
    signatureName: '',
  });

  const setState = (patch) =>
    setStateRaw(prev => ({ ...prev, ...(typeof patch === 'function' ? patch(prev) : patch) }));

  const timerRef = useRef(null);
  const authenticatorsRef = useRef([]);
  const scrollHandlerRef = useRef(null);
  const attachedScrollHandlerRef = useRef(null);

  const handleVCSignedWalletRedirect = () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const vcSign = urlParams.get('vcSign');
      if (!vcSign) return;

      try {
        urlParams.delete('vcSign');
        window.history.replaceState({}, document.title, `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`);
      } catch (e) {
        // ignore
      }

      const storedQrList = JSON.parse(localStorage.getItem(VC_SIGN_STORAGE.QrInfoList) || '[]');
      const storedSignerGuid = localStorage.getItem(VC_SIGN_STORAGE.SignerGuid);
      const storedCert = JSON.parse(localStorage.getItem(VC_SIGN_STORAGE.Certificate) || 'null');
      const storedRequestId = localStorage.getItem(VC_SIGN_STORAGE.RequestId);

      const vcPresentationStatusToSend = 'Approved';

      const updatePresentationStatusSafe = async () => {
        try {
          const viDMobileUserGuid = getViDMobileUserGUIDFromOauthToken();
          if (viDMobileUserGuid && storedRequestId) {
            await vcService.updateCredentialPresentationStatus(
              viDMobileUserGuid,
              storedRequestId,
              vcPresentationStatusToSend
            );
          }
        } catch (e) {
          // don't break UX if status update fails
        }
      };

      if (Array.isArray(storedQrList) && storedQrList.length > 1) {
        updatePresentationStatusSafe();

        const remaining = storedQrList.slice(1);
        localStorage.setItem(VC_SIGN_STORAGE.QrInfoList, JSON.stringify(remaining));

        const nextRedirectURL = (remaining && remaining[0] && remaining[0].Data) ? remaining[0].Data : null;
        if (nextRedirectURL) {
          window.location.href = nextRedirectURL;
          return;
        }
      }

      if (Array.isArray(storedQrList) && storedQrList.length === 1) {
        updatePresentationStatusSafe();

        localStorage.removeItem(VC_SIGN_STORAGE.QrInfoList);
        localStorage.removeItem(VC_SIGN_STORAGE.RequestId);

        if (
          storedSignerGuid &&
          props.selectedDoc &&
          props.selectedDoc.SignerDTO &&
          props.selectedDoc.SignerDTO.SignerGUI &&
          storedSignerGuid !== props.selectedDoc.SignerDTO.SignerGUI
        ) {
          setState({
            showError: true,
            errorType: 'VC_SIGN',
            errorData: 'Wallet signature redirect does not match current document',
          });
          return;
        }

        if (!storedCert) {
          setState({
            showError: true,
            errorType: 'VC_SIGN',
            errorData: 'Missing wallet signature data',
          });
          return;
        }

        const accessMethod = state.accessMethod;
        setState({
          showVCSignatureModal: false,
          showKeyVaultModal: false,
          certificateSelected: storedCert,
          certificateKeyVaultPin: '',
          loadingSignatureProcess: true,
        });

        const qesacBody = {
          CertGUID: storedCert.GUID,
          PIN: '',
          CertType: storedCert.CertType,
          AccessMethod: accessMethod,
        };

        vcService
          .QuesacSignature(storedSignerGuid, qesacBody)
          .then(() => {
            handleSignatureSuccess(204, KEYVAULT);
          })
          .catch((error) => {
            setState({
              showError: true,
              errorType: 'VC_SIGN',
              errorData: (error && error.response && error.response.data) ? error.response.data : (error && error.message ? error.message : 'Error executing QESAC signature'),
              loadingSignatureProcess: false,
            });
          });
        localStorage.removeItem(VC_SIGN_STORAGE.Certificate);
        localStorage.removeItem(VC_SIGN_STORAGE.SignerGuid);
      }
    } catch (e) {
      // ignore
    }
  };

  /** requestId = value emitted by completeSignatureCallback
   *  cidSuffix = value after ':' in credentialSubject.cid coming from callback
   */
  const handleWalletSignatureSocketSuccess = (requestId, cidSuffix) => {
    try {
      const viDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
      if (!viDMobileUserGUID || !requestId || !cidSuffix) {
        return;
      }

      const { certificateSelected } = state;
      if (!certificateSelected || !selectedDoc || !selectedDoc.SignerDTO) {
        return;
      }

      vcService.updateCredentialPresentationStatus(viDMobileUserGUID, requestId, 'accepted')
        .then(() => {
          const accessMethod = state.accessMethod;
          const qesacBody = {
            CredentialId: cidSuffix,
            AccessMethod: accessMethod,
          };

          setState({
            showVCSignatureModal: false,
            showKeyVaultModal: false,
            certificateSelected,
            certificateKeyVaultPin: '',
            loadingSignatureProcess: true,
          });

          vcService
            .QuesacSignature(requestId, qesacBody)
            .then(() => {
              handleSignatureSuccess(204, KEYVAULT);
            })
            .catch((error) => {
              setState({
                showError: true,
                errorType: error.response.status,
                errorData:
                  (error &&
                    error.response &&
                    error.response.data) ||
                  (error && error.message
                    ? error.message
                    : 'Error executing QESAC signature'),
                loadingSignatureProcess: false,
              });
            });
        })
        .catch((err) => {
          setState({
            showError: true,
            errorType: 'VC_SIGN',
            errorData: (err && err.response && err.response.data) || (err && err.message) || 'Error updating presentation status',
            showVCSignatureModal: false,
          });
        });
    } catch (_) {
      // swallow errors, do not impact UI
    }
  };

  const focusInput = (input) => {
    /**The stimeout is necesary to wait until the DOM is loaded */
    if (input) setTimeout(function () { input.focus(); }, 1);
  };

  const handleModalSignatureSuccess = (signatureName, showModalKey, certificatePinKey, certificatePin) => {
    setState({
      loadingSignatureProcess: true,
      showNoPinConfirmationModal: false,
      [showModalKey]: false,
      [certificatePinKey]: certificatePin,
      triggerSign: true,
      signatureName,
    });
  };

  const handleModalSignatureOtpSuccess = (signatureName, showModalKeyPin, showModalKeyOtp, certificatePinKey, certificatePin, certificateOtp) => {
    const { isUanatacaQualified } = state;
    if (isUanatacaQualified) {
      setState({ [showModalKeyOtp]: false, showUanatacaModalPin: true, certificateUanatacaOtp: certificateOtp });
      return;
    }

    handleModalSignatureSuccess(signatureName, showModalKeyPin, certificatePinKey, certificatePin);
  };

  const handleModalSignatureValidatedIdSuccess = (signatureName, showModalKeyPin, showModalKeyOtp, certificatePinKey, certificatePin, certificateOtp) => {
    const { isValidatedIdQualified } = state;
    if (isValidatedIdQualified) {
      setState({ [showModalKeyOtp]: false, showValidatedIdModalPin: true, certificateValidatedIdOtp: certificateOtp });
      return;
    }
    handleModalSignatureSuccess(signatureName, showModalKeyPin, certificatePinKey, certificatePin);
  };

  const handleClose = () => {
    setState({
      showSignModal: false,
      showRejectModal: false,
      showKeyVaultModal: false,
      showVCSignatureModal: false,
      showFirmaRemotaModal: false,
      showRedTrustModal: false,
      showSoftwareModal: false,
      showUanatacaModalPin: false,
      showUanatacaModalOtp: false,
      showValidatedIdModalPin: false,
      showValidatedIdModalOtp: false,
      showSwisscomModal: false,
      showAutofirmaModal: false,
      showNebulaModal: false,
      showSwisscomConfirmationModal: false,
      showNoPinConfirmationModal: false,
      showIvnosysModal: false,
      loadingSignatureProcess: false,
      loadingRejectingProcess: false,
      loadingSwisscomCheck: false,
      loadingSwisscomRequest: false,
      loadingSignatureProcessAutofirma: false,
      certificateSoftwarePin: '',
      certificateKeyVaultPin: '',
      certificateFirmaRemotaPin: '',
      certificateRedTrustPin: '',
      certificateUanatacaPin: '',
      certificateUanatacaOtp: '',
      certificateValidatedIdPin: '',
      certificateValidatedIdOtp: '',
      certificateNebulaPin: '',
      certificateIvnosysPin: '',
      nebulaStep1: false,
      nebulaStep2: false,
      nebulaStep3: false,
      NBauthenticator: '',
      NBChallenge: '',
      showAdditionalSignaturesDisclaimer: false,
      showChallengeError: false,
      textAdditionalSignaturesDisclaimer: '',
      titleAdditionalSignaturesDisclaimer: '',
      showErrorModalSelectedPage: false,
    });
  };

  const doLogOut = () => {
    sessionStorage.clear();
    stopTimer();
    setState({ redirect: true });
  };

  const startTimer = () => {
    timerRef.current = setInterval(() => setState(prev => ({
      time: prev.time + 1
    })), 60000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
  };

  const loadUserData = () => {
    setState({ loading: true });

    return ProfileService.getUserData()
      .then(res => {
        return res.data;
      })
      .catch(function (error) {
        if (error && error.response && error.response.status === 401) {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true });
          startTimer();
        } else if (error.response) {
          setState({
            errorType: error.response.status,
            errorData: error.response.data,
            showError: true
          });
        }
        throw error;
      });
  };

  const getUserCertificates = (overrideUserData, overrideUserCertificatesAuth) => {
    const _userData = overrideUserData !== undefined ? overrideUserData : state.userData;
    const _userCertificatesAuth = overrideUserCertificatesAuth !== undefined ? overrideUserCertificatesAuth : state.userCertificatesAuth;

    return CertificateService.getUserCertificates(_userData.legalid)
      .then(res => {
        return res.data;
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true });
          startTimer();
        }
        if (error.response.status === 404) {
          // Show Autofirma cert by default
          if (_userCertificatesAuth && _userCertificatesAuth.Local) {
            const certificate = {
              CertType: "Autofirma"
            };
            const certificatesList = <>
              <ListGroup.Item
                key={"Autofirma"}
                action
                variant="light"
                onClick={() => handleCertSelection(certificate)}
              >
                <ul className="list-container">
                  <li>{t('general.alias')}: Autofirma</li>
                  <li>{t('general.type')}: Autofirma </li>
                  <li>{t('general.expiration-date')}: --</li>
                </ul>
              </ListGroup.Item>
            </>
            setState({ certificatesList });
            return [];
          }
          if (!_userCertificatesAuth || (!_userCertificatesAuth.Swisscom && !_userCertificatesAuth.Autofirma)) {
            setState({ certificatesList: <p>{t('documents.cert-type-selection-empty')}</p> });
            return [];
          }
          if (_userCertificatesAuth.Swisscom || _userCertificatesAuth.Autofirma)
            return [];
        }

        if (error.response) {
          setState({
            errorType: error.response.status,
            errorData: error.response.data,
            showError: true
          });
        }

        throw error;
      });
  };

  const loadViDMobileUserCertificateTypes = () => {
    return CertificateService.getCertificateTypes()
      .then(res => {
        return res.data;
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true });
          startTimer();
        } else if (error.response) {
          setState({
            errorType: error.response.status,
            errorData: error.response.data,
            showError: true
          });
        }
        throw error;
      });
  };

  const loadViDMobileUserCertificateList = () => {
    loadUserData()
      .then(res => {
        if (res) {
          const userData = res;
          setState({ userData });
          loadViDMobileUserCertificateTypes()
            .then(res => {
              res.Nebula = true;
              const userCertificatesAuth = res;
              setState({ userCertificatesAuth });
              getUserCertificates(userData, userCertificatesAuth)
                .then(res => {
                  if (userCertificatesAuth === null) {
                    var ViDMobileUserAllowSWCerts = true;
                  } else {
                    ViDMobileUserAllowSWCerts = userCertificatesAuth.Software;
                    var ViDMobileUserAllowFirmaRemotaCerts = userCertificatesAuth.FirmaRemota;
                    var ViDMobileUserAllowKeyVaultCerts = userCertificatesAuth.KeyVault;
                    var ViDMobileUserAllowRTCerts = userCertificatesAuth.RedTrust;
                    var ViDMobileUserAllowUTCerts = userCertificatesAuth.Uanataca;
                    var ViDMobileUserAllowSwisscomCerts = userCertificatesAuth.Swisscom;
                    var ViDMobileUserAllowAutofirma = userCertificatesAuth.Local;
                    var ViDMobileUserAllowNebulaCerts = userCertificatesAuth.Nebula;
                    var ViDMobileUserAllowValidatedIdCerts = userCertificatesAuth.ValidatedID;
                    var ViDMobileUserAllowIvnosysCerts = userCertificatesAuth.Ivnosys;
                  }
                  var userCertsFiltered = res.reduce(function (userCertsAllowed, certificate) {
                    if ((certificate.CertType === "FirmaRemota" && ViDMobileUserAllowFirmaRemotaCerts) ||
                      (certificate.CertType === "KeyVault" && ViDMobileUserAllowKeyVaultCerts) ||
                      (certificate.CertType === "Software" && ViDMobileUserAllowSWCerts) ||
                      (certificate.CertType === "RedTrust" && ViDMobileUserAllowRTCerts) ||
                      (certificate.CertType === "Uanataca" && ViDMobileUserAllowUTCerts) ||
                      (certificate.CertType === "Nebula" && ViDMobileUserAllowNebulaCerts) ||
                      (certificate.CertType === "ValidatedID" && ViDMobileUserAllowValidatedIdCerts) ||
                      (certificate.CertType === "Ivnosys" && ViDMobileUserAllowIvnosysCerts)) {
                      userCertsAllowed.push(certificate);
                    }
                    return userCertsAllowed;
                  }, []);
                  if (ViDMobileUserAllowSwisscomCerts) {
                    userCertsFiltered.push({
                      CertType: "Swisscom",
                      ExpirationDate: "-",
                      certalias: "Swisscom"
                    });
                  }
                  if (ViDMobileUserAllowAutofirma) {
                    userCertsFiltered.push({
                      CertType: "Autofirma",
                      ExpirationDate: "-",
                      certalias: "Autofirma"
                    });
                  }
                  var vuserCertsFiltered = userCertsFiltered;
                  if (selectedDoc.SignerDTO.CentralizedCertificateInfo) {
                    // return all certificates if doc doesnt have any assigned or return only assigned certificate
                    if (selectedDoc.SignerDTO.CentralizedCertificateInfo.Guid !== null && userCertsFiltered) {
                      vuserCertsFiltered = userCertsFiltered.reduce(function (userCertsAllowed, certificate) {
                        if (!selectedDoc.SignerDTO.CentralizedCertificateInfo.Guid || (certificate.GUID === selectedDoc.SignerDTO.CentralizedCertificateInfo.Guid)) {
                          userCertsAllowed.push(certificate);
                        }
                        return userCertsAllowed;
                      }, []);
                    }
                  }

                  if (typeof vuserCertsFiltered !== 'undefined' && vuserCertsFiltered.length > 0) {
                    var certificatesList = vuserCertsFiltered.map(certificate => {
                      if (certificate.CertType === "ValidatedID") {
                        return <ListGroup.Item
                          key={certificate.GUID + certificate.certalias}
                          action
                          variant="light"
                          onClick={() => handleCertSelection(certificate)}
                        >
                          <ul className="list-container">
                            <li>{t('general.alias')}: {certificate.DN ? certificate.DN : certificate.certalias}</li>
                            <li>{t('general.type')}: Validated ID</li>
                            <li>{t('general.expiration-date')}: {certificate.ExpirationDate}</li>
                          </ul>
                        </ListGroup.Item>
                      }
                      if (certificate.CertType === "FirmaRemota") {
                        return <ListGroup.Item
                          key={certificate.GUID + certificate.certalias}
                          action
                          variant="light"
                          onClick={() => handleCertSelection(certificate)}
                        >
                          <ul className="list-container">
                            <li>{t('general.alias')}: {certificate.certalias}</li>
                            <li>{t('general.type')}: TrustPRO</li>
                            <li>{t('general.expiration-date')}: {certificate.ExpirationDate}</li>
                          </ul>
                        </ListGroup.Item>
                      }
                      else if (certificate.certalias !== "Swisscom" && certificate.certalias !== "Autofirma") {
                        return <ListGroup.Item
                          key={certificate.GUID + certificate.certalias}
                          action
                          variant="light"
                          onClick={() => handleCertSelection(certificate)}
                        >
                          <ul className="list-container">
                            <li>{t('general.alias')}: {certificate.AuthenticationType === 'OTP' && certificate.DN} {certificate.AuthenticationType !== 'OTP' && certificate.certalias}</li>
                            <li>{t('general.type')}: {certificate.CertType}</li>
                            <li>{t('general.expiration-date')}: {certificate.ExpirationDate}</li>
                          </ul>
                        </ListGroup.Item>
                      }
                      else {
                        return <ListGroup.Item
                          key={certificate.GUID + certificate.certalias}
                          action
                          variant="light"
                          onClick={() => handleCertSelection(certificate)}
                        >
                          <ul className="list-container">
                            <li>{certificate.certalias}</li>
                          </ul>
                        </ListGroup.Item>
                      }
                    });
                    setState({ vuserCertsFiltered: vuserCertsFiltered, certificatesList: certificatesList });
                  }
                  else {
                    setState({
                      certificatesList: <p>{t('documents.cert-type-selection-empty')}</p>,
                      showSignModal: true
                    });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          console.log('no user data')
        }
      })
      .catch(function (error) {
        console.log(error)
      });
  };

  const handleCertSelection = (certificate) => {
    var showKeyVaultModal = false;
    var showVCSignatureModal = false;
    var showFirmaRemotaModal = false;
    var showSoftwareModal = false;
    var showRedTrustModal = false;
    var showSwisscomModal = false;
    var showAutofirmaModal = false;
    var showNebulaModal = false;
    var showNoPinConfirmationModal = false;
    var showDesktopOnlyModal = false;
    let showIvnosysModal = false;
    // 1) Prefer wallet VC flow for KeyVault when IsWalletLinked is true
    if (certificate.CertType === "KeyVault" && certificate.IsWalletLinked) {
      // If user is on mobile/tablet, show the desktop-only informational modal
      if (isMobile() || isTablet()) {
        showDesktopOnlyModal = true;
      } else {
        showVCSignatureModal = true;
      }
    }
    // 2) If not wallet flow, check no-PIN confirmation flow
    else if (checkShowNoPinConfirmationModal(certificate)) {
      showNoPinConfirmationModal = true;
      setState({ nebulaPinRequired: false });
    }
    // 3) Fallback to existing flows
    else {
      if (certificate.CertType === "KeyVault" && certificate.AuthenticationType === "PIN") {
        showKeyVaultModal = true;
      }
      if (certificate.CertType === "KeyVault" && certificate.AuthenticationType === "SMS") {
        showKeyVaultModal = true;
        keyVaultSendOTP(certificate);
      }
      if (certificate.CertType === "FirmaRemota" && certificate.AuthenticationType === "APP") {
        showFirmaRemotaModal = true;
      }
      if (certificate.CertType === "FirmaRemota" && certificate.AuthenticationType === "SMS") {
        showFirmaRemotaModal = true;
        firmaRemotaSendOTP();
      }
      if (certificate.CertType === "Software") {
        showSoftwareModal = true;
      }
      if (certificate.CertType === "RedTrust") {
        showRedTrustModal = true;
      }
      if (certificate.CertType === "Uanataca") {
        isQualifiedCertificate(certificate.AuthenticationType);
      }
      if (certificate.CertType === "ValidatedID") {
        isValidatedIdCertificateQualified(certificate.AuthenticationType);
      }
      if (certificate.CertType === "Swisscom") {
        showSwisscomModal = true;
      }
      if (certificate.CertType === "Autofirma") {
        showAutofirmaModal = true;
        signDocAutofirma();
      }
      if (certificate.CertType === "Nebula") {
        getAuthenticators();
        showNebulaModal = true;
      }
      if (certificate.CertType === "Ivnosys") {
        showIvnosysModal = true;
      }

    }
    setState({
      showKeyVaultModal: showKeyVaultModal,
      showVCSignatureModal,
      showFirmaRemotaModal: showFirmaRemotaModal,
      showSoftwareModal: showSoftwareModal,
      showRedTrustModal: showRedTrustModal,
      showSwisscomModal: showSwisscomModal,
      showAutofirmaModal: showAutofirmaModal,
      showNebulaModal: showNebulaModal,
      showNoPinConfirmationModal: showNoPinConfirmationModal,
      showDesktopOnlyModal: showDesktopOnlyModal,
      showSignModal: false,
      showIvnosysModal,
      certificateSelected: certificate
    });
  };

  const isQualifiedCertificate = (authenticationType) => {
    if (authenticationType === OTP) {
      setState({ isUanatacaQualified: true });
      const { oauthTokenB64 } = state;
      var viDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

      const body = {
        Uses: 1
      };

      postManagementSignature(generateUanatacaOtpUri(viDMobileUserGUID), body, oauthTokenB64)
        .then(res => {
          setState({ showUanatacaModalOtp: true });
        })
        .catch(function (error) {
          handleSignatureError(error, UANATACA_CERTIFICATE_PIN_KEY);
        });

      return;
    }

    setState({ showUanatacaModalPin: true });
  };

  const isValidatedIdCertificateQualified = (authenticationType) => {
    if (authenticationType === OTP) {
      setState({ isValidatedIdQualified: true });
      const { oauthTokenB64 } = state;
      var viDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

      const body = {
        Uses: 1
      };

      postManagementSignature(generateValidatedIdOtpUri(viDMobileUserGUID), body, oauthTokenB64)
        .then(res => {
          setState({ showValidatedIdModalOtp: true });
        })
        .catch(function (error) {
          handleSignatureError(error, VALIDATEDID_CERTIFICATE_PIN_KEY);
        });

      return;
    }

    setState({ showValidatedIdModalPin: true });
  };

  const rejectDoc = (selectedOption, rejectReason) => {
    const { accessMethod } = state;
    const { SignerDTO, DocGUI } = selectedDoc;
    setState({
      loadingRejectingProcess: true,
      showRejectModal: false,
    });

    const data = selectedOption ? {
      RejectionReason: rejectReason,
      RejectionOption: selectedOption.Id,
    } : {
      RejectionReason: rejectReason,
      AccessMethod: accessMethod
    };

    DocumentService.rejectDocument(SignerDTO.SignerGUI, data)
      .then(res => {
        if (res.status === 204) {
          Utils.removeItemFromSelectedDocsInSessionByGuid(DocGUI);
          setState({ loadingRejectingProcess: false });
          props.showRejectedDocHandler();
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true });
          startTimer();
        } else if (error.response) {
          setState({
            errorType: error.response.status,
            errorData: error.response.data,
            showError: true,
            loadingRejectingProcess: false
          });
          props.handlePreviouslyRejectedDocError(error, true);
        }
      });
  };

  const signDocKeyVault = () => {
    const { oauthTokenB64, certificateSelected, certificateKeyVaultPin, accessMethod } = state;
    const { SignerDTO } = selectedDoc;

    const dataJson = {
      CertGUID: certificateSelected.GUID,
      PIN: certificateKeyVaultPin,
      CertType: certificateSelected.CertType,
      AccessMethod: accessMethod
    };

    postPrivSignature(generateKeyVaultUri(SignerDTO.SignerGUI), dataJson, oauthTokenB64)
      .then(res => {
        handleSignatureSuccess(res.status, KEYVAULT);
      })
      .catch(function (error) {
        handleSignatureError(error, KEYVAULT_CERTIFICATE_PIN_KEY);
      });
  };

  const signDocSoftware = () => {
    const { oauthTokenB64, certificateSoftwarePin, accessMethod } = state;
    const { SignerDTO } = selectedDoc;

    const dataJson = {
      PinAuthentication: certificateSoftwarePin,
      AccessMethod: accessMethod
    };

    postPrivSignature(generateSoftwareUri(SignerDTO.SignerGUI), dataJson, oauthTokenB64)
      .then(res => {
        handleSignatureSuccess(res.status, SOFTWARE);
      })
      .catch(function (error) {
        handleSignatureError(error, SOFTWARE_CERTIFICATE_PIN_KEY);
      });
  };

  const handleNoPinDocSignature = () => {
    setState({
      loadingSignatureProcess: true,
      showNoPinConfirmationModal: false
    });
    const { certificateSelected } = state;

    if (certificateSelected.CertType === "KeyVault") {
      signDocKeyVault();
    }
    if (certificateSelected.CertType === "FirmaRemota") {
      signDocFirmaRemota();
    }
    if (certificateSelected.CertType === "Software") {
      signDocSoftware();
    }
    if (certificateSelected.CertType === "RedTrust") {
      signDocRedTrust();
    }
    if (certificateSelected.CertType === "Nebula") {
      setState({ loadingSignatureProcess: false, showNebulaModal: true });
      getAuthenticators();
    }
  };

  const firmaRemotaOpenSession = () => {
    const { oauthTokenB64, certificateFirmaRemotaPin } = state;

    const dataJson = {
      OTP: certificateFirmaRemotaPin
    };

    putManagementSignature(generateFirmaRemotaSessionUri(), dataJson, oauthTokenB64)
      .then(res => {
        setState({ sessionOpened: true });
      })
      .catch(function (error) {
        handleGenericError(error);

        props.handlePreviouslyRejectedDocError(error, true);
      });
  };

  const firmaRemotaCloseSession = () => {
    const { oauthTokenB64, certificateFirmaRemotaPin } = state;

    const dataJson = {
      OTP: certificateFirmaRemotaPin
    };

    deleteManagementSignature(generateFirmaRemotaSessionUri(), dataJson, oauthTokenB64)
      .then(res => {
        setState({ certificateFirmaRemotaPin: '' });
      })
      .catch(function (error) {
        handleGenericError(error);
      })
      .finally(() => {
        setState({ certificateFirmaRemotaPin: '' });
      });
  };

  const getViDMobileUserGUIDFromOauthToken = () => {
    const { oauthTokenB64 } = state;
    var tokenParts = oauthTokenB64.split(".");
    var jsonTokenInfo = atob(tokenParts[1]);
    var tokenInfo = JSON.parse(jsonTokenInfo);
    return tokenInfo.sub;
  };

  const handleSessionExpiredError = (status) => {
    if (status === 401) {
      /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
      setState({ sessionExpired: true });
      startTimer();
    }
  };

  const handleGenericError = (error) => {
    handleSessionExpiredError(error.response.status);

    if (error.response.status !== 401) {
      setState({
        errorType: error.response.status,
        errorData: error.response.data,
        showError: true
      });
    }
  };

  const firmaRemotaSendOTP = () => {
    const { oauthTokenB64 } = state;
    var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

    putPrivSignature(generateFirmaRemotaOTPUri(ViDMobileUserGUID), "", oauthTokenB64)
      .then(res => {
        //firmaRemota SMS OTP sent
      })
      .catch(function (error) {
        handleGenericError(error);
      });
  };

  const keyVaultSendOTP = (certificate) => {
    const { oauthTokenB64, accessMethod } = state;
    const dataJson = {
      AccessMethod: accessMethod
    };

    postPrivSignature(generateKeyVaultSendOTPUri(certificate.GUID), dataJson, oauthTokenB64)
      .then(res => {
        //keyVault SMS OTP sent
      })
      .catch(function (error) {
        handleGenericError(error);
      });
  };

  const signDocFirmaRemota = () => {
    const { oauthTokenB64, certificateSelected, certificateFirmaRemotaPin, sessionOpened, accessMethod } = state;
    const { SignerDTO, DocGUI } = selectedDoc;

    if (certificateFirmaRemotaPin !== "") {
      firmaRemotaOpenSession();
    }

    const dataJson = {
      CertGUID: certificateSelected.GUID,
      PIN: certificateFirmaRemotaPin,
      CertType: certificateSelected.CertType,
      AccessMethod: accessMethod
    };

    postPrivSignature(generateFirmaRemotaUri(SignerDTO.SignerGUI), dataJson, oauthTokenB64)
      .then(res => {
        if (res.status === 204) {
          if (sessionOpened) {
            firmaRemotaCloseSession();
          }
          Utils.removeItemFromSelectedDocsInSessionByGuid(DocGUI);
          setState({ loadingSignatureProcess: false, certificateFirmaRemotaPin: '' });
          props.showSignedDocHandler();
        }
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true });
          startTimer();
        } else {
          setState({
            loadingSignatureProcess: false,
            errorType: error.response.status,
            errorData: error.response.data,
            showError: true,
            certificateFirmaRemotaPin: ''
          });
          props.handlePreviouslyRejectedDocError(error, true);
        }
        if (sessionOpened) {
          firmaRemotaCloseSession();
        }
      });
  };

  const signDocRedTrust = () => {
    const { oauthTokenB64, certificateSelected, certificateRedTrustPin, accessMethod } = state;
    const { SignerDTO } = selectedDoc;

    const dataJson = {
      CertGUID: certificateSelected.GUID,
      PIN: certificateRedTrustPin,
      CertType: certificateSelected.CertType,
      AccessMethod: accessMethod
    };

    postPrivSignature(generateRedTrustUri(SignerDTO.SignerGUI), dataJson, oauthTokenB64)
      .then(res => {
        handleSignatureSuccess(res.status, REDTRUST);
      })
      .catch(function (error) {
        handleSignatureError(error, REDTRUST_CERTIFICATE_PIN_KEY);
      });
  };

  const handleSignatureSuccess = (status, signatureName) => {
    const { SignerDTO } = selectedDoc;

    if (status === 204) {
      Utils.removeItemFromSelectedDocsInSessionByGuid(SignerDTO.SignerGUI);

      var targetState = {};

      props.showSignedDocHandler();

      if (signatureName === SOFTWARE)
        targetState.certificateSoftwarePin = '';
      if (signatureName === KEYVAULT)
        targetState.certificateKeyVaultPin = '';
      if (signatureName === REDTRUST)
        targetState.certificateRedTrustPin = '';
      if (signatureName === FIRMAREMOTA)
        targetState.certificateFirmaRemotaPin = '';
      if (signatureName === UANATACA)
        targetState.certificateUanatacaPin = '';
      if (signatureName === VALIDATEDID)
        targetState.certificateValidatedIdPin = '';
      if (signatureName === NEBULA)
        targetState.certificateNebulaPin = '';

      setState(prev => ({ ...targetState, docsSigned: prev.docsSigned + 1 }));
    }
  };

  const handleSignatureError = (error, certificatePinKey) => {
    if (error.response.status === 401) {
      setState({ sessionExpired: true });
      startTimer();
    } else {
      setState({
        loadingSignatureProcess: false,
        errorType: error.response.status,
        errorData: error.response.data,
        showError: true,
        [certificatePinKey]: '',
        certificateUanatacaOtp: '',
        certificateValidatedIdOtp: ''
      });

      props.handlePreviouslyRejectedDocError(error, true);
    }
  };

  const signDocUanataca = () => {
    const { oauthTokenB64, certificateSelected, certificateUanatacaPin, certificateUanatacaOtp, isUanatacaQualified, accessMethod } = state;
    const { SignerDTO } = selectedDoc;

    var dataJson = {
      CertGUID: certificateSelected.GUID,
      PIN: certificateUanatacaPin,
      CertType: certificateSelected.CertType,
      AccessMethod: accessMethod
    };

    if (isUanatacaQualified) {
      const dataJsonQF = Object.assign(dataJson, { OTP: certificateUanatacaOtp });
      dataJson = dataJsonQF;
    }

    postPrivSignature(generateUanatacaUri(SignerDTO.SignerGUI), dataJson, oauthTokenB64)
      .then(res => {
        handleSignatureSuccess(res.status, UANATACA);
      })
      .catch(function (error) {
        handleSignatureError(error, UANATACA_CERTIFICATE_PIN_KEY);
      });
  };

  const signDocValidatedId = () => {
    const { oauthTokenB64, certificateSelected, certificateValidatedIdPin, certificateValidatedIdOtp, isValidatedIdQualified, accessMethod } = state;
    const { SignerDTO } = selectedDoc;

    var dataJson = {
      CertGUID: certificateSelected.GUID,
      PIN: certificateValidatedIdPin,
      CertType: certificateSelected.CertType,
      AccessMethod: accessMethod
    };

    if (isValidatedIdQualified) {
      const dataJsonQF = Object.assign(dataJson, { OTP: certificateValidatedIdOtp });
      dataJson = dataJsonQF;
    }

    postPrivSignature(generateValidatedIdUri(SignerDTO.SignerGUI), dataJson, oauthTokenB64)
      .then(res => {
        handleSignatureSuccess(res.status, VALIDATEDID);
      })
      .catch(function (error) {
        handleSignatureError(error, VALIDATEDID_CERTIFICATE_PIN_KEY);
      });
  };

  const signDocSwisscom = () => {
    const { oauthTokenB64, accessMethod } = state;
    const { SignerDTO } = selectedDoc;
    const dataJson = {
      AccessMethod: accessMethod
    };
    postPrivSignature(generateSwisscomUri(SignerDTO.SignerGUI), dataJson, oauthTokenB64)
      .then(res => {
        var swisscomReturnObj = res.data;
        var isUrlDefined = swisscomReturnObj.RedirectURL ? true : false;

        if (isUrlDefined) {
          Utils.openTab(swisscomReturnObj.RedirectURL);
        }

        setState({ swisscomRedirectURL: swisscomReturnObj.RedirectURL, swisscomRequestID: swisscomReturnObj.RequestID, loadingSwisscomRequest: false });
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true });
          startTimer();
        } else {
          setState({
            errorType: error.response.status,
            errorData: error.response.data,
            showError: true,
            showSwisscomConfirmationModal: false,
            showSwisscomModal: false,
            loadingSwisscomCheck: false,
            loadingSwisscomRequest: false
          });
          props.handlePreviouslyRejectedDocError(error, true);
        }
      });
  };

  const completeSwisscomSignature = () => {
    const { oauthTokenB64, swisscomRequestID, accessMethod } = state;
    const { SignerDTO, DocGUI } = selectedDoc;
    const dataJson = {
      AccessMethod: accessMethod
    };

    postPrivSignature(generateSwisscomUri(SignerDTO.SignerGUI, swisscomRequestID), dataJson, oauthTokenB64)
      .then(res => {
        Utils.removeItemFromSelectedDocsInSessionByGuid(DocGUI);
        setState({ loadingSwisscomCheck: false, showSwisscomConfirmationModal: false });
        props.showSignedDocHandler();
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
            setState({ sessionExpired: true });
            startTimer();
          } else if (error.response.status === 409) {
            setState({
              loadingSwisscomCheck: false,
              swisscomError: t('documents.swisscom-error')
            });
          } else {
            setState({
              errorType: error.response.status,
              errorData: error.response.data,
              showError: true,
              showSwisscomConfirmationModal: false,
              showSwisscomModal: false,
              loadingSwisscomCheck: false
            });
          }
        }
        else {
          setState({
            errorType: 'Undefined',
            errorData: 'Network error',
            showError: true,
            showSwisscomConfirmationModal: false,
            showSwisscomModal: false,
            loadingSwisscomCheck: false
          });
        }
      });
  };

  const signDocAutofirma = () => {
    loadAppAFirma().then(() => {
      doSelectCert();
    });
  };

  const loadAppAFirma = () => {
    return new Promise((resolve, reject) => {
      window.AutoScript.cargarAppAfirma();
      window.AutoScript.setStickySignatory(true);
      setTimeout(() => { resolve(); }, 1500);
    });
  };

  const getAuthenticators = () => {
    const { oauthTokenB64 } = state;
    var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
    setState({ loadingNebula: true });

    const dataJson = {
      IsSign: true
    };

    postManagementSignature(generateNebulaAuthUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
      .then(res => {
        authenticatorsRef.current = res.data.Authenticators;

        if (authenticatorsRef.current.length === 1) {
          setState({
            nebulaStep1: false,
            nebulaStep2: true,
            NBauthenticator: authenticatorsRef.current[0]
          });
          // Pass value directly: setState is async, state.NBauthenticator would be stale here
          sendAuthenticator(authenticatorsRef.current[0]);
        } else {
          setState({
            nebulaStep1: true,
            NBAuthenticator: state.NBAuthenticator
          });
        }
      })
      .catch(function (error) {
        setState({ loadingNebula: false });
        handleGenericError(error);
      });
  };

  const handleAuthenticatorChange = (e) => {
    setState({ NBauthenticator: e.target.value });
  };

  const sendAuthenticator = (authenticatorOverride) => {
    const { oauthTokenB64, NBauthenticator } = state;
    var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
    setState({ loadingNebula: true });

    const authenticator = authenticatorOverride !== undefined ? authenticatorOverride : NBauthenticator;
    const dataJson = {
      Authenticator: authenticator,
    };

    postManagementSignature(generateNebulaAuthMiddleUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
      .then(res => {
        setState({
          nebulaStep1: false,
          nebulaStep2: true,
          loadingNebula: false
        });
      })
      .catch(function (error) {
        setState({ loadingNebula: false });
        handleGenericError(error);
      });
  };

  const sendChallenge = () => {
    const { oauthTokenB64, NBChallenge, nebulaPinRequired } = state;
    var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
    setState({ loadingNebula: true, nebulaStep2: false });

    const dataJson = {
      Challenge: NBChallenge,
    };

    postManagementSignature(generateNebulaAuthEndUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
      .then(res => {
        if (!nebulaPinRequired) {
          signDocNebula();
        }
        setState({
          nebulaStep1: false,
          nebulaStep2: false,
          nebulaStep3: true,
          loadingNebula: false,
          NBChallenge: ''
        });
      })
      .catch(function (error) {
        if (error.response.data.includes("integrationUnauthorized")) {
          setState({
            showChallengeError: true,
            loadingNebula: false,
            NBChallenge: ''
          });
        } else {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true, loadingNebula: false, NBChallenge: '' });
          startTimer();
        }
      });
  };

  const signDocSelection = (type) => {
    const { sessionOpened, docsSigned } = state;

    if (docsSigned !== 1) {
      if (type === SOFTWARE) {
        signDocSoftware();
      }
      if (type === KEYVAULT) {
        signDocKeyVault();
      }
      if (type === REDTRUST) {
        signDocRedTrust();
      }
      if (type === FIRMAREMOTA) {
        signDocFirmaRemota();
      }
      if (type === UANATACA) {
        signDocUanataca();
      }
      if (type === SWISSCOM) {
        signDocSwisscom();
      }
      if (type === NEBULA) {
        signDocNebula();
      }
      if (type === VALIDATEDID) {
        signDocValidatedId();
      }
      if (type === IVNOSYS) {
        handleSignatureSuccess(204, IVNOSYS);
      }

      return;
    }

    if (sessionOpened) {
      firmaRemotaCloseSession();
    }

    setState({
      loadingSignatureProcess: false,
      certificateSoftwarePin: '',
      certificateKeyVaultPin: '',
      certificateFirmaRemotaPin: '',
      certificateRedTrustPin: '',
      certificateUanatacaPin: '',
      certificateUanatacaOtp: '',
      certificateNebulaPin: '',
      certificateValidatedIdPin: '',
      certificateValidatedIdOtp: '',
      signedDoc: true
    });
  };

  const signDocNebula = () => {
    const { oauthTokenB64, certificateSelected, certificateNebulaPin, accessMethod } = state;
    const { SignerDTO } = selectedDoc;
    setState({
      loadingSignatureProcess: true,
      showNebulacaModal: false,
      showNoPinConfirmationModal: false,
      nebulaStep3: false,
    });

    const dataJson = {
      CertGUID: certificateSelected.GUID,
      PIN: certificateNebulaPin,
      CertType: certificateSelected.CertType,
      AccessMethod: accessMethod
    };

    postPrivSignature(generateNebulaUri(SignerDTO.SignerGUI), dataJson, oauthTokenB64)
      .then(res => {
        handleSignatureSuccess(res.status, NEBULA);
      })
      .catch(function (error) {
        handleSignatureError(error, NEBULA_CERTIFICATE_PIN_KEY);
      });
  };

  const doSelectCert = () => {
    try {
      window.AutoScript.selectCertificate(
        "",
        showCertCallback,
        showErrorCallback
      );

    } catch (e) {
      console.log("Type: " + window.AutoScript.getErrorType() + "\nMessage: " + window.AutoScript.getErrorMessage());
      setState({ showAutofirmaModal: false });
    }
  };

  // FUNCION DE FIRMA
  const doSign = (data) => {
    const { SignerDTO } = selectedDoc;

    setState({ autofirmaPercentage: 40 });

    const certificateBody = {
      CertType: data.certType,
      CertsData: [data.certsData],
      HashAlgorithm: data.hashAlgorithm
    };

    DocumentService.uploadLocalSignatureCertificate(SignerDTO.SignerGUI, certificateBody)
      .then(res => {
        if (res.status === 204) {
          doAutofirmaPreSignature()
            .then(response => {
              setState({ autofirmaPercentage: 60 });
              try {
                /* SE FILTRA POR EL CN SELECCIONADO PREVIAMENTE Y
                 * SE ACTIVA EL HEADLESS PARA EVITAR QUE VUELVA A SOLICITAR EL CERTIFICADO
                 * */
                window.AutoScript.sign(
                  response.PreSignatureContentDNIe,
                  "SHA512withRSA",
                  "NONE",
                  null,
                  showSignResultCallback,
                  showErrorCallback);
              } catch (e) {
                setState({ loadingSignatureProcessAutofirma: false });
                try {
                  console.log("Type: " + window.AutoScript.getErrorType() + "\nMessage: " + window.AutoScript.getErrorMessage());
                } catch (ex) {
                  console.log("Error: " + e);
                }
              }
            })
            .catch(function (error) {
              setState({
                loadingSignatureProcessAutofirma: false,
                showAutofirmaModal: false,
                errorType: t('documents.autofirma-title'),
                errorData: error.message,
                showError: true
              });
            });
        }
      })
      .catch(function (error) {
        setState({
          loadingSignatureProcessAutofirma: false,
          showAutofirmaModal: false,
          errorType: t('documents.autofirma-title'),
          errorData: error.message,
          showError: true
        });
      });
  };

  const doAutofirmaPreSignature = () => {
    const { SignerDTO } = selectedDoc;

    return DocumentService.getPreSignature(SignerDTO.SignerGUI)
      .then(res => {
        return res.data;
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true });
          startTimer();
        }
        throw error;
      });
  };

  // FUNCION CALLBACK DE AUTOFIRMA PARA ENVIAR EL RESULTADO DE LA FIRMA
  const showSignResultCallback = (signatureB64, certificateB64) => {
    const { clientIp, ipData } = state;
    const { SignerDTO } = selectedDoc;
    const evidenceLocation = (ipData.latitude + ipData.longitude).toString;
    const browserStringified = JSON.stringify(browser);

    setState({ autofirmaPercentage: 80 });

    const signatureBody = {
      Signature: signatureB64,
      HashAlgorithm: "SHA512",
      IpAddress: clientIp,
      Location: evidenceLocation,
      From: browserStringified
    };

    DocumentService.uploadLocalSignature(SignerDTO.SignerGUI, signatureBody)
      .then(res => {
        setState({ autofirmaPercentage: 100 });
        closeAutofirmaProcess();
      })
      .catch(function (error) {
        setState({
          loadingSignatureProcessAutofirma: false,
          showAutofirmaModal: false,
          errorType: t('documents.autofirma-title'),
          errorData: error.message,
          showError: true
        });
      });
  };

  const closeAutofirmaProcess = () => {
    setTimeout(() => {
      setState({
        loadingSignatureProcessAutofirma: false,
        showAutofirmaModal: false
      });
      refreshView();
    }, 2000);
  };

  const refreshView = () => {
    props.showSignedDocHandler();
  };

  // FUNCION CALLBACK DE AUTORFIRMA PARA RECOGER EL CERTIFICADO A USAR
  const showCertCallback = (certificateB64) => {
    const { SignerDTO } = selectedDoc;

    setState({
      loadingSignatureProcessAutofirma: true,
      autofirmaPercentage: 20
    });

    var pki = window.forge.pki;
    var certPEM = "-----BEGIN CERTIFICATE-----\n" + certificateB64 + "\n-----END CERTIFICATE-----";
    var cert = pki.certificateFromPem(certPEM);
    var CN = cert.subject.getField('CN').value;

    var data = {
      signerGUI: SignerDTO.SignerGUI,
      certType: SignerDTO.TypeOfID,
      certsData: certificateB64,
      hashAlgorithm: "SHA512",
      cn: CN
    };
    doSign(data);
  };

  const showErrorCallback = (errorType, errorMessage) => {
    setState({
      showAutofirmaModal: false,
      errorType: t('documents.autofirma-title'),
      errorData: <p>{t('documents.autofirma-error')} <a href='https://firmaelectronica.gob.es/Home/Descargas.html' rel="noopener noreferrer" target='_blank'>https://firmaelectronica.gob.es/Home/Descargas.html</a></p>,
      showError: true
    });
  };

  const getClientData = () => {
    (async () => {
      const clientIp = await publicIp.v4();
      const ipData = await ipLocation(clientIp);
      setState({
        clientIp: clientIp,
        ipData: ipData
      });
    })();
  };

  const getImagesHeightsAverage = () => {
    const images = document.getElementsByClassName("pdf-images");

    const imagesArray = Array.from(images);

    let totalHeight = 0;

    imagesArray.forEach((image) => {
      totalHeight += image.offsetHeight;
    });

    return totalHeight / imagesArray.length;
  };

  const setActualPageNumberWhenScrollChanged = () => {
    const renderedPages = renderedDoc.length;

    var container_height = document.getElementsByClassName("pdf-container")[0].offsetHeight;
    const image_height = getImagesHeightsAverage();

    var scroll_height = image_height * renderedPages;

    /**Scroll position*/
    var scroll_position = document.getElementsByClassName("pdf-container")[0].scrollTop;
    var scroll_max_value = scroll_height - container_height;
    var scroll_percentage = Math.abs((scroll_position / scroll_max_value) * 100);

    var page_ratio = 100 / renderedPages; /**6,25  */
    var actualPagePosition = scroll_percentage / page_ratio; /**Por cada 6,25 saldrá 1 */
    var max_page_ratio = 100 / page_ratio; /**Número de páginas en total */

    /**Sumamos 1 de base para no mostrar el valor 0 */
    var actualPagePositionAbsolute = 1 + Math.floor(actualPagePosition);

    /**Comprobamos que no llegue al máximo para no mostrar el máximo de páginas +1 y le adjudicamos el valor máximo */
    if (actualPagePositionAbsolute >= max_page_ratio) {
      actualPagePositionAbsolute = renderedPages;
    }

    const actualPageNumber = documentMapService.getDocumentPageNumber(actualPagePositionAbsolute - 1);
    if (!actualPageNumber) return;

    if (forceDocumentView && actualPageNumber === totalPages) {
      setState({ allPagesViewed: true });
    }

    setState({
      actualPage: actualPageNumber,
      selectedPage: actualPageNumber
    });

    /** check if there is a neighboring page to load */
    const pageToFetch = documentMapService.determineNeighborPageNumberToFetch(actualPageNumber);
    if (!loadingMorePages && pageToFetch !== -1) {
      renderSpecificPage(pageToFetch);
    }
  };

  const calculateDocumentHeight = () => {
    const { selectedPage } = state;

    const images = document.getElementsByClassName("pdf-images");

    if (!images || images.length === 0) {
      console.log("No hay imágenes cargadas para calcular la altura.");
      return;
    }

    let totalHeight = 0;
    const totalImages = images.length;

    Array.from(images).forEach((img) => {
      const handleImageLoad = () => {
        totalHeight += img.offsetHeight;

        let newLoadedImagesCount;
        setStateRaw(prev => {
          newLoadedImagesCount = prev.loadedImagesCount + 1;
          return { ...prev, loadedImagesCount: newLoadedImagesCount };
        });

        if (newLoadedImagesCount === totalImages) {
          setState({ totalDocumentHeight: totalHeight });
          props.onDocumentHeightUpdate(totalHeight, selectedPage, renderedDoc);
        }

        img.removeEventListener('load', handleImageLoad);
      };

      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });
  };

  const actualAttachedPage = () => {
    /**REVISAR SI SE PUEDE USAR EL MISMO MÉTODO DE ACTUAL PAGE */
    var container_height = document.getElementsByClassName("pdf-container-2")[0].offsetHeight;
    var image_height = document.getElementsByClassName("attached-pdf-images")[0].offsetHeight;
    var scroll_height = image_height * docsAttachedRendered.length;

    /**Scroll position*/
    var scroll_position = document.getElementsByClassName("pdf-container-2")[0].scrollTop;
    var scroll_max_value = scroll_height - container_height;
    var scroll_percentage = Math.abs((scroll_position / scroll_max_value) * 100);

    var page_ratio = 100 / docsAttachedRendered.length; /**6,25  */
    var actual_page = scroll_percentage / page_ratio; /**Por cada 6,25 saldrá 1 */
    var max_page_ratio = 100 / page_ratio; /**Número de páginas en total */

    /**Sumamos 1 de base para no mostrar el valor 0 */
    var actual_page_absolute = 1 + Math.floor(actual_page);

    /**Comprobamos que no llegue al máximo para no mostrar el máximo de páginas +1 y le adjudicamos el valor máximo */
    if (actual_page_absolute >= max_page_ratio) {
      actual_page_absolute = docsAttachedRendered.length;
    }
    setState({ actualAttachedPage: actual_page_absolute });
  };

  const changeAttachedTab = (k) => {
    setState({
      tabKey: k,
      actualAttachedPage: 1
    });
    document.getElementsByClassName("pdf-container-2")[0].scrollTop = 0;
  };

  const toggleSignatureReason = () => {
    setState(prev => ({ showSignatureReason: !prev.showSignatureReason }));
  };

  const handleSign = (validateDisclaimer = true) => {
    if (selectedDoc.SignerDTO.DisclaimerInfo.Display && validateDisclaimer) {
      getDisclaimerMessage();
      return;
    }

    setState({ showAdditionalSignaturesDisclaimer: false });

    if (state.vuserCertsFiltered.length === 1) {
      handleCertSelection(state.vuserCertsFiltered[0]);
      return;
    }

    setState({ showSignModal: true });
  };

  const getDisclaimerMessage = () => {
    const type = 'SIGNATURE_MULTIPOSITION_SIMPLE';
    const { language } = state;
    const { SignerDTO } = selectedDoc;
    const iso2Language = language.slice(0, 2);

    return DocumentService.getDisclaimerMessage(SignerDTO.SignerGUI, type, iso2Language)
      .then(res => {
        const disclaimerData = res.data;
        setState({
          showAdditionalSignaturesDisclaimer: true,
          textAdditionalSignaturesDisclaimer: disclaimerData.Text,
          titleAdditionalSignaturesDisclaimer: disclaimerData.Title
        });
        return res.data;
      })
      .catch(function (error) {
        if (error.response && error.response.status === 401) {
          /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
          setState({ sessionExpired: true });
          startTimer();
        }
        throw error;
      });
  };

  const onHeaderInfoClick = () => {
    setState(prev => ({ showHeaderInfo: !prev.showHeaderInfo }));
  };

  const createDownloadElementAndClick = (fileURL, fileName) => {
    var anchorElement = window.document.createElement('a');
    anchorElement.href = fileURL;
    anchorElement.target = '_self';
    anchorElement.download = fileName;
    var event = window.document.createEvent("MouseEvents");
    event.initEvent("click", true, false);
    anchorElement.dispatchEvent(event);
  };

  const base64ToArrayBuffer = (data) => {
    var bString = window.atob(data);
    var bLength = bString.length;
    var bytes = new Uint8Array(bLength);
    for (var i = 0; i < bLength; i++) {
      var ascii = bString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };

  const handleDownloadDocument = () => {
    const { DocGUI: docGuid, FileName: fileName } = selectedDoc;

    DocumentService.downloadDocument(docGuid)
      .then(response => {
        const docContent = response.data.DocContent;
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
          var byteCharacters = atob(docContent);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], { type: 'application/pdf' });
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        }
        else {
          var newBlob = new Blob([base64ToArrayBuffer(docContent)], { type: 'application/octet-stream' });
          var fileURL = window.URL.createObjectURL(newBlob);
          createDownloadElementAndClick(fileURL, fileName);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handlePageInput = (e) => {
    const inputValue = e.target.value;
    setState({ selectedPage: inputValue });
  };

  const handlePageSelection = () => {
    const { selectedPage } = state;
    const pageNumber = parseInt(selectedPage, 10);

    if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > totalPages) {
      setState({ showErrorModalSelectedPage: true });
      return;
    }
    setState({ isManualNavigation: true, selectedPage: pageNumber });

    const pagePosition = documentMapService.getPagePosition(pageNumber);
    if (pagePosition !== null && pagePosition !== -1) {
      documentMapService.setScroll('pdf-container', pageNumber, renderedDoc.length);
    } else {
      renderSpecificPage(pageNumber);
    }

    setTimeout(() => {
      setState({ isManualNavigation: false });
    }, 500);
  };

  // Update scroll handler refs on every render so event listeners always use the latest closures
  scrollHandlerRef.current = setActualPageNumberWhenScrollChanged;
  attachedScrollHandlerRef.current = actualAttachedPage;

  useEffect(() => {
    Utils.appendScript("/assets/js/autoscript.js");
    Utils.appendScript("/assets/js/forge.min.js");
    getClientData();
    loadViDMobileUserCertificateList();

    const pdfContainer = document.getElementsByClassName('pdf-container')[0];
    const stableScrollHandler = (...args) => scrollHandlerRef.current(...args);
    pdfContainer.addEventListener("scroll", stableScrollHandler);

    let attachedContainer = null;
    let stableAttachedScrollHandler = null;
    if (documentAttatchmentsList.length > 0) {
      attachedContainer = document.getElementsByClassName('pdf-container-2')[0];
      stableAttachedScrollHandler = (...args) => attachedScrollHandlerRef.current(...args);
      attachedContainer.addEventListener("scroll", stableAttachedScrollHandler);
    }

    calculateDocumentHeight();

    // Check URL params for VC wallet-based signature actions
    handleVCSignedWalletRedirect();

    // Check URL params for Ivnosys actions
    const urlParams = new URLSearchParams(window.location.search);
    const ivnosysPreSignAuth = urlParams.get('ivnosysPreSignAuth');
    const ivnosysInitSign = urlParams.get('ivnosysInitSign');

    if (ivnosysPreSignAuth || ivnosysInitSign) {
      // recover process data from localStorage
      const currentIvnosysProcess = JSON.parse(localStorage.getItem("currentIvnosysProcess"));
      const { certificateSelected, signerGuid } = currentIvnosysProcess;

      // find doc by signerGuid
      const docForIvnosys = pendingSignatures.find(doc => doc.SignerDTO.SignerGUI === signerGuid);

      if (docForIvnosys) {
        setState({
          showIvnosysModal: true,
          certificateSelected,
          selectedDoc: docForIvnosys
        });
      }
    }

    return () => {
      pdfContainer.removeEventListener("scroll", stableScrollHandler);
      if (attachedContainer && stableAttachedScrollHandler) {
        attachedContainer.removeEventListener("scroll", stableAttachedScrollHandler);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setState({ loadedImagesCount: 0 });
    calculateDocumentHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderedDoc]);

  useEffect(() => {
    const { signatureName } = state; 
    if (state.triggerSign) {
      signDocSelection(signatureName);

      setState({ triggerSign: false }); // reset
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [state.triggerSign]);

  const {
    showSignModal, showRejectModal, sessionExpired, language, time, certificatesList,
    showKeyVaultModal, showFirmaRemotaModal, showRedTrustModal, showSoftwareModal, showUanatacaModalPin, showUanatacaModalOtp, showAutofirmaModal, loadingSignatureProcess, loadingRejectingProcess,
    showVCSignatureModal, certificateSelected, showError, errorType, errorData, actualPage, showNoPinConfirmationModal, tabKey, loadingSignatureProcessAutofirma, autofirmaPercentage, showSignatureReason, vuserCertsFiltered, showAdditionalSignaturesDisclaimer, rejectReason, titleAdditionalSignaturesDisclaimer,
    textAdditionalSignaturesDisclaimer, showValidatedIdModalPin, showValidatedIdModalOtp, showHeaderInfo, allPagesViewed, selectedPage, showErrorModalSelectedPage, showIvnosysModal, showDesktopOnlyModal
  } = state;
  const isDocSelected = checkedDocs && checkedDocs.includes(selectedDoc.SignerDTO.SignerGUI);
  const isSelectionLocked = !!(isDocSelectionLocked && isDocSelectionLocked(selectedDoc));
  const selectionLockTooltipKey = isSelectionLocked && getSelectionLockTooltipKey ? getSelectionLockTooltipKey(selectedDoc) : null;

  let images = renderedDoc.map((renderedImage, index) => {
    return <img
      key={index}
      alt="renderedImage"
      src={`data:image/jpeg;base64,${renderedImage}`}
      className="pdf-images"
      id={`pdf-page-${index + 1}`}
    />
  });

  const onCheck = () => {
    updateSelectedDocs(selectedDoc, !isDocSelected, PREVIEW);
  };

  var timeText = language === 'es' ? 'Hace ' + time + ' minutos' : language === 'en' ? time + ' minutes ago' : language === 'ca' ? 'Fa ' + time + ' minuts' : 'Hace ' + time + ' minutos';

  const columns = [{
    dataField: 'SignerName',
    text: t('documents.document-signers-table-name'),
    align: 'left',
    headerAlign: 'left'
  }, {
    dataField: 'UploadTime',
    text: t('documents.document-signers-table-delivery-date'),
    align: 'left',
    headerAlign: 'left'
  }, {
    dataField: 'OperationTime',
    text: t('documents.document-signers-table-signature-date'),
    align: 'left',
    headerAlign: 'left'
  }, {
    dataField: 'SignatureStatus',
    text: t('documents.document-signers-table-status'),
    headerAlign: 'center',
    formatter: (cellContent, row, rowIndex) => {
      if (cellContent !== null) {
        if (cellContent === 'Signed') {
          return <div className="signedCellbox">{cellContent}</div>
        }
        if (cellContent === 'Unsigned') {
          return <div className="unsignedCellbox">{cellContent}</div>
        }
        if (cellContent === 'Rejected') {
          return <div className="rejectedCellbox">{cellContent}</div>
        }
      }
      else {
        return <div className="undefinedCellbox">Undefined</div>
      }
    }
  }];

  const approvers = documentSigners.reduce((approversData, signer) => {
    if (Array.isArray(signer.Approvers) && signer.Approvers.length > 0) return [
      ...approversData,
      ...signer.Approvers
    ];

    return approversData;
  }, []);

  const showApproversTab = approvers.length > 0;

  const approversColumns = showApproversTab ? [{
    dataField: 'Email',
    text: t('profile.user-email'),
    align: 'left',
    headerAlign: 'left'
  }, {
    dataField: 'LegalId',
    text: t('profile.user-legalId'),
    align: 'left',
    headerAlign: 'left'
  }, {
    dataField: 'Name',
    text: t('documents.document-signers-table-name'),
    align: 'left',
    headerAlign: 'left'
  }] : [];

  const docIndex = pendingSignatures.findIndex((doc) => doc.DocGUI === selectedDoc.DocGUI);
  const isLastIndex = docIndex === pendingSignatures.length - 1;

  let rejectionOptions = [];

  if (selectedDoc.RejectionOptions) {
    rejectionOptions = selectedDoc.RejectionOptions;
  }

  if (selectedDoc.SignerDTO.RejectionOptions) {
    if (selectedDoc.SignerDTO.RejectionOptions.length > 0) {
      rejectionOptions = selectedDoc.SignerDTO.RejectionOptions;
    }
  }

  return (
    <div>
      <DesktopOnlyMessage show={showDesktopOnlyModal} onClose={() => setState({ showDesktopOnlyModal: false })} />
      {showError && (
        <ToastComponent
          onClose={() => setState({ showError: false })}
          show={showError}
          title={<>{t('general.error')} {errorType}</>}
          message={errorData}
          variant="error"
          closeButton
          zIndex={10}
        />
      )}
      {sessionExpired && (
        <ToastComponent
          show={sessionExpired}
          title={t('general.notification')}
          subtitle={timeText}
          variant="session-expired"
          zIndex={10}
          closeButton={false}
        >
          <p>{t('general.session-expired')}</p>
          <Button
            type="button"
            className="btn btn-primary"
            id="sign-all-docs"
            onClick={() => doLogOut()}
          >
            {t('general.accept')}
          </Button>
        </ToastComponent>
      )}
      {(renderedDoc.length === 0) &&
        <LoadingCircle centerVertically={true} />
      }
      {(renderedDoc.length > 0) &&
        <div>
          <div className="back-container" onClick={props.viewDocumentHandler}>
            <span><img src={iconBackButton} alt="back button" className="back-button" /> <span className="back-button-text">{t('documents.document-back-button')}</span></span>
          </div>
          {!isLastIndex &&
            <div className="next-container" onClick={props.seeNextDocument}>
              <span className="back-button-text"> {t('documents.document-next-button')} </span>&nbsp;&nbsp;<span><img src={iconNextButton} alt="back button" className="back-button" /> </span>
            </div>
          }
          <Tabs defaultActiveKey="document" id="uncontrolled-tab-example">
            <Tab eventKey="document" title={<span>{t('documents.document-tab-sign')}</span>}>

              <div className={`document-preview-header ${showHeaderInfo ? '' : 'invisible'}`}>
                <div className="data-group">
                  <img src={squareEyeBox} alt="Eye" className="" />
                  <label className="document-preview-title"><b>{selectedDoc.SignerDTO.SignerName}</b> {t('documents.dp-text1')}</label>
                </div>
                <div className="data-group">
                  <img src={squareDocBox} alt="Doc" className="" />
                  <label className="document-preview-name">{selectedDoc.FileName}</label>
                  <img src={downloadIcon} alt="Doc" className="download-icon" onClick={handleDownloadDocument} />
                </div>
                {!forceDocumentView && (
                  isSelectionLocked ? (
                    <div className="lock-container preview-lock-container">
                      <img src={lockIcon} alt="Lock Icon" className='icon' />
                      <div className="lock-container-popup">{t(selectionLockTooltipKey)}</div>
                    </div>
                  ) : (
                    <label className="check-container">{t('documents.select')}
                      <input onChange={onCheck} type="checkbox" checked={isDocSelected} />
                      <div className='checkmark'></div>
                    </label>
                  )
                )}
                <span className="document-preview-count">
                  {totalPages > 4 ? (
                    <>
                      <input
                        className="page-selector"
                        type="text"
                        min="1"
                        max={totalPages}
                        value={selectedPage || ''}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (/^\d*$/.test(inputValue)) {
                            handlePageInput(e);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handlePageSelection();
                          }
                        }}
                      />
                      /{totalPages}
                    </>
                  ) : (
                    `${actualPage}/${totalPages}`
                  )}
                </span>
                <div className={`preview-toggler ${showHeaderInfo ? '' : 'plus-preview-toggler'}`} onClick={onHeaderInfoClick}>
                  {showHeaderInfo ? <img src={iconArrowUp} alt="Hide" /> : <img src={iconArrowDown} alt="Show" />}
                </div>
              </div>
              <div className="document-preview-container">
                <CustomModal
                  show={showSignModal}
                  handleHide={() => handleClose()}
                  title={t('documents.cert-type-selection')}
                  singleButton={true}
                >
                  <ListGroup defaultActiveKey="#link1">
                    {certificatesList}
                  </ListGroup>
                </CustomModal>
                <RejectionModal
                  showRejectModal={showRejectModal}
                  handleClose={handleClose}
                  rejectDoc={rejectDoc}
                  rejectReason={rejectReason}
                  certificateSelected={certificateSelected}
                  onChange={e => setState({ rejectReason: e.target.value })}
                  rejectionOptions={rejectionOptions}
                />
                <CustomModal
                  show={showErrorModalSelectedPage}
                  handleHide={() => handleClose()}
                  title={t("documents.warning")}
                  singleButton={true}
                >
                  <ListGroup defaultActiveKey="#link1">
                    {t("documents.error-modal-selected-page", { totalPages: totalPages })}
                  </ListGroup>
                </CustomModal>
                <CustomModal
                  text={textAdditionalSignaturesDisclaimer}
                  title={titleAdditionalSignaturesDisclaimer}
                  show={showAdditionalSignaturesDisclaimer}
                  handleHide={() => setState({ showAdditionalSignaturesDisclaimer: false })}
                  handleConfirm={() => handleSign(false)}
                />

                <KeyVaultSignature
                  show={showKeyVaultModal}
                  onClose={handleClose}
                  onSuccess={handleModalSignatureSuccess}
                  certificateSelected={certificateSelected} />

                <VCSignature
                  show={showVCSignatureModal}
                  onClose={handleClose}
                  vidMobileUserGuid={getViDMobileUserGUIDFromOauthToken()}
                  signerGuid={selectedDoc.SignerDTO.SignerGUI}
                  certificateSelected={certificateSelected}
                  onWalletSignSuccess={handleWalletSignatureSocketSuccess}
                />

                <FirmaRemota
                  show={showFirmaRemotaModal}
                  onClose={handleClose}
                  onSuccess={handleModalSignatureSuccess}
                  certificateSelected={certificateSelected} />

                <RedTrustSignature
                  show={showRedTrustModal}
                  onClose={handleClose}
                  onSuccess={handleModalSignatureSuccess} />

                <SoftwareSignature
                  show={showSoftwareModal}
                  onClose={handleClose}
                  onSuccess={handleModalSignatureSuccess} />

                <UanatacaSignature
                  showModalPin={showUanatacaModalPin}
                  showModalOtp={showUanatacaModalOtp}
                  onClose={handleClose}
                  onSuccessOtp={handleModalSignatureOtpSuccess}
                  onSuccess={handleModalSignatureSuccess} />

                <IvnosysSignature
                  showModalPin={showIvnosysModal}
                  onClose={handleClose}
                  onSuccess={handleModalSignatureSuccess}
                  certificateSelected={certificateSelected}
                  signerGuid={selectedDoc.SignerDTO.SignerGUI} />

                <ValidatedIdSignature
                  showModalPin={showValidatedIdModalPin}
                  showModalOtp={showValidatedIdModalOtp}
                  onClose={handleClose}
                  onSuccessOtp={handleModalSignatureValidatedIdSuccess}
                  onSuccess={handleModalSignatureSuccess} />

                <SwisscomSignature
                  parentState={state}
                  onClose={handleClose}
                  onSuccessSignDocSelection={() => {
                    setState({
                      showSwisscomModal: false,
                      showSwisscomConfirmationModal: true,
                      loadingSwisscomRequest: true
                    });
                    signDocSelection(SWISSCOM);
                  }}
                  onSuccess={() => {
                    setState({
                      loadingSwisscomCheck: true,
                      swisscomError: ''
                    });
                    completeSwisscomSignature();
                  }} />


                <CustomModal
                  show={showAutofirmaModal}
                  handleHide={() => handleClose()}
                  title={t('documents.autofirma-title')}
                  closable={true}
                  hideButtons={true}
                >
                  {!loadingSignatureProcessAutofirma && (
                    <>
                      <p>{t('documents.autofirma-text')}</p>
                      <LoadingCircle />
                    </>
                  )}
                  {loadingSignatureProcessAutofirma && (
                    <>
                      <p style={{ textAlign: 'center' }}>{t('general.sign-process')}</p>
                      <ProgressBar variant="success" now={autofirmaPercentage} label={`${autofirmaPercentage}%`} />
                    </>
                  )}
                </CustomModal>
                <CustomModal
                  show={showNoPinConfirmationModal}
                  handleHide={() => handleClose()}
                  handleConfirm={() => handleNoPinDocSignature()}
                  title={t('documents.no-pin-title')}
                  text={t('documents.no-pin-text')}
                />

                <NebulaSignature
                  onChangeFormControl={(e) => handleAuthenticatorChange(e)}
                  onSendAuthenticator={sendAuthenticator}
                  parentState={state}
                  authenticators={authenticatorsRef.current}
                  onClose={handleClose}
                  onChallengeChange={e => setState({ NBChallenge: e.target.value })}
                  onSendChallenge={sendChallenge}
                  onFocusInput={(input) => { focusInput(input); }}
                  onCertificatePinChange={e => setState({ certificateNebulaPin: e.target.value })}
                  onSignDoc={() => { setState({ loadingSignatureProcess: false, showNebulaModal: false }); signDocSelection(NEBULA); }}
                />

                <SigningProcessModal
                  showModal={loadingSignatureProcess}
                  showProcess={true}
                  signedDocs={0}
                  selectedDocs={1} />

                <RejectingProcessModal
                  show={loadingRejectingProcess} />



                <div className="pdf-container">
                  {images}
                </div>
              </div>

              {selectedDoc.SignerDTO.SignatureReason !== null &&
                <div className="bottom-content-signature-reason" style={{ height: showSignatureReason ? '21vh' : '11vh' }}>
                  <div className="signature-reason-container" style={{
                    height: showSignatureReason ? '60%' : '25%',
                    backgroundColor: showSignatureReason ? 'initial' : '#8E8E8E'
                  }}>
                    <span className="toggle-signature-reason"
                      onClick={() => toggleSignatureReason()}>
                      {showSignatureReason &&
                        <img className="arrow-down-icon" src={iconArrowDown} alt="arrow down" />}
                      {!showSignatureReason &&
                        <img className="arrow-down-icon" src={iconArrowUp} alt="arrow up" />}
                    </span>
                    {showSignatureReason &&
                      <div className="signature-reason-title-container">
                        <div className="sr-title-icon-container">
                          <img className="question-box-icon" src={iconQuestionBox}
                            alt="question box" />
                          <p className="signature-reason-title">{t('documents.signature-reason-title')}</p>
                        </div>
                      </div>
                    }
                    {showSignatureReason &&
                      <div className="signature-reason-text-container">
                        <p className="signature-reason-text">
                          {selectedDoc.SignerDTO.SignatureReason !== null ? selectedDoc.SignerDTO.SignatureReason : t('documents.signature-reason-empty')}
                        </p>
                      </div>
                    }
                  </div>
                  {vuserCertsFiltered &&
                    <div className="signature-reason-buttons-container"
                      style={{ height: showSignatureReason ? '40%' : '75%' }}>
                      <Button
                        type="button"
                        id="rejectModalbutton"
                        className="action-button reject"
                        onClick={() => setState({ showRejectModal: true })}
                      >
                        {t('general.reject')}
                      </Button>
                      <Button
                        type="button"
                        id="signModalButton"
                        className="btn btn-primary action-button"
                        onClick={handleSign}
                        disabled={forceDocumentView && !allPagesViewed}
                      >
                        {t('general.sign')}
                      </Button>
                    </div>
                  }
                </div>
              }

              {selectedDoc.SignerDTO.SignatureReason === null &&
                <div className="buttons-container">
                  <Button
                    type="button"
                    id="rejectModalbutton"
                    className="action-button reject"
                    onClick={() => setState({ showRejectModal: true })}
                  >
                    {t('general.reject')}
                  </Button>
                  <Button
                    type="button"
                    id="signModalButton"
                    className="btn btn-primary action-button"
                    onClick={handleSign}
                    disabled={forceDocumentView && !allPagesViewed}
                  >
                    {t('general.sign')}
                  </Button>
                </div>
              }
            </Tab>

            <Tab eventKey="signers" title={<span>{t('documents.document-tab-signers')}</span>}>
              <div className="signers-table-container">
                <ToolkitProvider
                  keyField="GUID"
                  data={documentSigners}
                  columns={columns}
                  bootstrap4
                >
                  {
                    props => (
                      <div>
                        <BootstrapTable
                          hover
                          striped
                          bordered={false}
                          {...props.baseProps}
                        />
                      </div>
                    )
                  }
                </ToolkitProvider>
              </div>
            </Tab>
            {
              showApproversTab && <Tab eventKey="approvers" title={<span>{t('approvals.approvals')}</span>}>
                <div className="signers-table-container">
                  <ToolkitProvider
                    keyField="GUID"
                    data={approvers}
                    columns={approversColumns}
                    bootstrap4
                  >
                    {
                      props => (
                        <div>
                          <BootstrapTable
                            hover
                            striped
                            bordered={false}
                            {...props.baseProps}
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </div>
              </Tab>
            }
            <Tab eventKey="attachments" title={<span><img src={iconAttachedDocs} alt="" className="tab-icons" /> {t('documents.document-tab-attachments')}</span>} tabClassName={documentAttatchmentsList.length === 0 ? 'tab-hide' : ''}>
              <Tab.Container
                defaultActiveKey={tabKey}
                onSelect={k => changeAttachedTab(k)}
              >
                <Row bsPrefix="attachments-row row">
                  <Col sm={3} bsPrefix="left-side-menu-col col">
                    <Nav variant="pills" className="flex-column">
                      {attDocArray}
                    </Nav>
                  </Col>
                  <Col sm={9} bsPrefix="right-side-menu-col col">
                    <Tab.Content bsPrefix="tab-content tab-content3">
                      <Tab.Pane eventKey={tabKey}>
                        {
                          documentAttatchmentsList.length > 0 &&
                          <DocumentAttachments tabKey={tabKey} documentAttatchmentsList={documentAttatchmentsList} signerGuid={selectedDoc.SignerDTO.SignerGUI} />
                        }
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Tab>
          </Tabs>
        </div>
      }
    </div>
  );
};

export default withTranslation()(DocumentPreview);
